var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3 mr-10",staticStyle:{"z-index":"9999999999","position":"absolute","right":"0"}},_vm._l((_vm.alerts),function(alert){return _c('v-row',{key:alert.message},[_c('v-col',[_c('Alert',{attrs:{"message":alert.message,"type":alert.type}})],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }